
document.addEventListener('DOMContentLoaded', function () {

  const mindfulSection = document.querySelector('.mindful-living');
  if (!mindfulSection) return;

  const mindfulLivingSwiper = new Swiper(".mindful_living_swiper", {
    loop: true,
    slidesPerView: 1.2,
    spaceBetween: 20,
    navigation: {
      nextEl: ".mindful_living_arrow_right",
      prevEl: ".mindful_living_arrow_left",
    },
    breakpoints: {
      600: { slidesPerView: 2, spaceBetween: 20 },
      800: { slidesPerView: 2.5 },
      1300: { slidesPerView: 3.2, spaceBetween: 40 },
    },
  });

  function loadVideosInSection() {
    mindfulSection.querySelectorAll('video[data-src]').forEach(video => {
      video.src = video.dataset.src;
      video.removeAttribute('data-src');
      video.load();
    });
  }

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadVideosInSection();
          obs.disconnect();
        }
      });
    }, {
      rootMargin: '200px',
      threshold: 0.1
    });

    observer.observe(mindfulSection);
  } else {
    loadVideosInSection();
  }

  document.querySelectorAll('.video-container').forEach(container => {
    const video = container.querySelector('video');
    const playBtn = container.querySelector('.playIcon, .play-button');

    if (!video || !playBtn) return;

    playBtn.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();

      document.querySelectorAll('.video-container video').forEach(v => {
        if (v !== video) {
          v.pause();
          const btn = v.closest('.video-container')?.querySelector('.playIcon, .play-button');
          if (btn) btn.style.display = 'flex';
        }
      });

      if (video.paused) {
        video.play().catch(() => {});
        playBtn.style.display = 'none';
      } else {
        video.pause();
        playBtn.style.display = 'flex';
      }
    });

    video.addEventListener('ended', () => {
      playBtn.style.display = 'flex';
    });
  });

  document.querySelectorAll('.mindful_living_swiper_card').forEach(card => {
    card.addEventListener('click', function (e) {
      if (e.target.classList.contains('playIcon') || e.target.classList.contains('play-button')) return;
      const link = this.querySelector('a');
      if (link) window.location.href = link.href;
    });
  });

});
